import { useEffect } from 'react'
import tagManager from 'react-gtm-module'

import getConfig from 'next/config'

import type { NextConfig } from 'next/config'
const { publicRuntimeConfig } = getConfig() as NextConfig

/**
 * Google Tag Manager.
 */
export const GoogleTagManager = () => {
  const googleTagManagerId = publicRuntimeConfig?.GOOGLE_TAG_MANAGER_ID

  useEffect(() => {
    if (googleTagManagerId && typeof window === 'object') {
      tagManager.initialize({
        gtmId: googleTagManagerId,
      })
    }
  }, [googleTagManagerId])

  return null
}
